// Core
// Components
import { DialogContent } from '@components/ui/dialog'
import type React from 'react'

export default function ModalContent({
  children,
  className,
  position = 'center',
  onPointerDownOutside,
  closeButton = true,
  onEscapeKeyDown,
}: {
  closeButton?: boolean
  children: React.ReactNode
  className?: string
  position?: 'center' | 'left' | 'right'
  onPointerDownOutside?: (event: any) => void
  onEscapeKeyDown?: (event: any) => void
}): JSX.Element {
  return (
    <DialogContent
      onEscapeKeyDown={onEscapeKeyDown}
      closeButton={closeButton}
      position={position}
      className={className}
      onPointerDownOutside={onPointerDownOutside}
    >
      {children}
    </DialogContent>
  )
}
